module.exports = __webpack_public_path__ + "img/india.2deaf97e.png";